import React,{useEffect} from "react";
import { Link } from "react-router-dom";

const KvkkPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-semibold mb-6">Kişisel Verilerin Korunması Kanunu (KVKK)</h1>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Giriş</h2>
        <p>
        Şirketimiz Çelik Tuhafiye tarafından https://celiktuhafiye.com internet sitesi üzerinden 
yürütülen faaliyetlerle ilgili olarak sizleri bilgilendirmek isteriz. Bir elektronik ticaret 
platformu olan web sitemizde alışveriş yapabilmek için üyelik şartı bulunmamaktadır. 
Dolayısıyla platformumuzda üyelik bir hizmet koşulu olarak sunulmamaktadır. Üye 
olmadan alışveriş yapma seçeneğinden farklı olarak üyelik seçeneği; alışkanlıkları, 
alışveriş geçmişi, incelemeleri takip edilip değerlendirilerek kendisine özgü 
kişiselleştirilmiş bir hizmet almak isteyen kullanıcılar için tasarlanmıştır. Kişiye özgü bu 
avantajların sunulması için ise bazı kişisel verilerinizin aşağıda detaylandırıldığı şekilde 
belirtilen amaçlarla işlenmesi, anlaşmalı profesyonel iş ortaklarımızla paylaşılması ve 
teknoloji alanındaki tedarikçilerimiz tarafından sağlanan programlarımıza ve/veya 
sistemlerimize kaydedilmesi gerekebilmektedir. Siz müşterilerimizin memnuniyetinin 
sağlanması için işlenmesi gereken kişisel verilerinizden bazıları; Kişisel Verilerin 
Korunması Kanunu’nda yer alan ve rızaya tabi olmayan veri işleme şartlarının 
kapsamında olmaması nedeniyle, ancak siz müşterilerimizin konu özelinde beyan 
edeceği açık rızaya bağlıdır. Açık rızanıza bağlı olarak; 
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. İŞLENEN KİŞİSEL VERİLER VE TOPLAMA YÖNTEMLERİ:</h2>
        <p>
        Siz Müşterilerimizin çevrimiçi ve/veya basılı formlar vasıtasıyla paylaştığı kimlik 
bilgileriniz (isim, soyisim), iletişim bilgileriniz (e-posta adresi, fatura ve teslimat 
adresleri, cep telefonu numarası); internet sitemizi kullanımız sırasında toplanan 
müşteri işlem bilgileriniz (talep bilgileri, sipariş bilgileri, fatura bilgileri, müşteri 
yorumları), pazarlama bilgileriniz (çerez kayıtları, alışveriş geçmişi, açık veya örtülü 
kullanıcı reytingleri), işlem güvenliği bilgileri (IP Adresi Bilgileri, İnternet Sitesi Giriş Çıkış 
Bilgileri, Kullanıcı Adı Bilgileri, Şifre Bilgileri, Bağlantı Zamanı / Süresi gibi Trafik Verileri) 
internet sitemizi kullanırken internet tarayıcınızdaki tercihlerinize göre toplanabilecek 
lokasyon verileriniz işlenecektır.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. İŞLENEN KİŞİSEL VERİLERİN İŞLEME AMAÇLARI VE HUKUKİ SEBEBİ:</h2>
        <p>
        Yukarıda sayılan kişisel verileriniz, rıza göstererek üyemiz olmanız halinde; size özel 
reklam, promosyon ve kampanyaların oluşturulması, hedef kitle belirlenmesi, müşteri 
hareketleriniz takip edilerek kullanıcı deneyiminizi arttırıcı faaliyetlerin yürütülmesi ve 
internet sitemizin geliştirilmesi ve müşteri ihtiyaçlarına göre kişiselleştirilmesi, 
doğrudan ve doğrudan olmayan pazarlama, kişiye özel pazarlama ve yeniden pazarlama 
faaliyetlerinin yürütülmesi, kişiye özel segmentasyon, hedefleme, analiz ve şirket içi 
raporlama faaliyetlerinin yürütülmesi, pazar araştırmaları, müşteri memnuniyeti 
aktivitelerinin planlanması ve icrası ile müşteri ilişkileri yönetimi süreçlerinin 
planlanması ve icrası amaçlarıyla dahil olmak üzere şirketimizin sunduğu ürün ve/veya 
hizmetlere bağlılık oluşturulması ve/veya arttırılması süreçlerinin planlanması ve icrası, 
tüm bu açıklanan kapsamlarda sizinle iletişim faaliyetlerinin yürütülmesi kapsamında; 
KVKK’nın 5. maddesinin 1. fıkrası “açık rıza” hukuki sebebine bağlı olarak işlenebilecek 
ve aynı amaçlar ve hukuki sebep kapsamında yurtiçi ve yurtdışındaki üçüncü kişilerle 
paylaşılabilecektir.
        </p>

      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. İŞLENEN KİŞİSEL VERİLERE İLİŞKİN HAKLARINIZ:</h2>
        <p>
        KVKK’nın 11. maddesi kapsamında; Kişisel verilerinizin işlenip işlenmediğini öğrenme, 
Kişisel verileriz işlenmişse buna ilişkin bilgi talep etme, Kişisel verilerinizin işlenme 
amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme, Yurt içinde 
veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme, Kişisel verilerinizin 
eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme, KVKK 
mevzuatında öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok 
edilmesini isteme, Eksik veya yanlış verilerinizin düzeltilmesi ile kişisel verilerinizin 
silinmesi veya yok edilmesini talep etmesi halinde, bu durumun kişisel verilerinizin 
aktarıldığı üçüncü kişilere bildirilmesini isteme, İşlenen verilerinizin münhasıran 
otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhe bir sonucun ortaya 
çıkması durumunda sonuca itiraz etme ve Kişisel verilerinizin kanuna aykırı olarak 
işlenmesi sebebiyle zarara uğraması halinde bu zararın giderilmesini talep etme, 
Haklarına sahipsiniz. Yukarıda yer alan tüm kişisel verilerinizin belirtilen işleme 
amaçları ile sınırlı olmak üzere işlenmesine hiçbir baskı altında kalmadan ve açık 
biçimde muvafakat ettiğinizi, üye ol sayfasındaki “üye ol” butonuna tıklayarak kabul 
etmiş olacaksınız.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">5. AYDINLATMA METNİ 
KİŞİSEL VERİLERİN KORUNMASINA İLİŞKİN AYDINLATMA METNİ</h2>
        <p>
        Çelik Tuhafiye tarafından aktarılan kişisel verilerin korunması konusundaki temel 
bilgilere aşağıda yer verilmiştir. Şirketimiz, 6698 sayılı Kişisel Verilerin Korunması 
Kanunu (“KVKK”) m. 10’dan doğan aydınlatma yükümlülüğünü yerine getirmek amacıyla 
aşağıdaki açıklamaları müşterilerimizin ve web-sitemizi kullanan 3. kişilerin dikkatine 
sunar. Şirketimiz işbu Kişisel Verilerin Korunması Hakkında Açıklama metnini 
yürürlükteki mevzuatta yapılabilecek değişiklikler çerçevesinde her zaman güncelleme 
hakkını saklı tutar. 
1) Şirketimizin kişisel verileri toplamasının yasal dayanağı nedir? 
Müşterilerimizin kişisel verilerinin kullanılması konusunda çeşitli kanunlarda 
düzenlemeler bulunmaktadır. En başta KVKK ile kişisel verilerin korunması esasları 
belirlenmiştir. Ayrıca 6563 Sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun da 
kişisel verilerin korunmasına ilişkin hüküm içermektedir. 5237 Sayılı Türk Ceza Kanunu 
hükümleri yoluyla da kişisel verilerin korunması için bazı hallerde cezai yaptırımlar 
öngörülmüştür. Diğer yandan, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve
Mesafeli Sözleşmeler Yönetmeliği’nden doğan yükümlülüklerimizin ifası amacıyla 
verilerin toplanması ve kullanılması gerekmektedir. 
2) Şirketimiz kişisel verilerin toplanmasında hangi yöntemleri kullanıyor? 
http://celiktuhafiye.com web sitesinden işlem yapan müşterilerimizin verdikleri veriler, 
müşterilerimizin rızaları ve mevzuat hükümleri uyarınca şirketimiz tarafından 
işlenmektedir. Şirketimize ait olan http://celiktuhafiye.com web sitesi çerez (cookie) 
kullanan bir sitedir. Çerez; kullanılmakta olan cihazın internet tarayıcısına ya da sabit 
diskine depolanarak söz konusu cihazın tespit edilmesine olanak tanıyan, çoğunlukla 
harf ve sayılardan oluşan bir dosyadır. http://celiktuhafiye.com, ziyaretçilerine daha iyi 
hizmet verebilmek amacıyla ve yasal yükümlülüğü çerçevesinde, işbu Kişisel Verilerin 
Korunması Hakkında Açıklama metninde belirlenen amaçlar ve kapsam dışında 
kullanılmamak kaydı ile gezinme bilgilerinizi toplayacak, işleyecek, üçüncü kişilerle 
paylaşacak ve güvenli olarak saklayacaktır. 
3) İnternet Sitesi Çerezleri Nasıl Kullanılmaktadır? 
http://celiktuhafiye.com; yaptığınız tercihleri hatırlamak ve web sitesi kullanımınızı 
kişiselleştirmek için kullanır. Bu kullanım parolanızı kaydeden ve web sitesi 
oturumunuzun sürekli açık kalmasını sağlayan, böylece her ziyaretinizde birden fazla 
kez parola girme zahmetinden kurtaran çerezleri ve web sitesine daha sonraki 
ziyaretlerinizde sizi hatırlayan ve tanıyan çerezleri içerir. http://celiktuhafiye.com web 
sitesine nereden bağlandığınız, web sitesi üzerinde hangi içeriği görüntülediğiniz ve 
ziyaretinizin süresi gibi web sitesini nasıl kullandığınızın izlenmesi dahil olmak üzere; 
web sitesini nasıl kullandığınızı belirlemek için kullanır. 
4) İnternet Sitesi üçüncü taraf çerezlerini reklam ve yeniden hedefleme için nasıl 
kullanmaktadır? 
http://celiktuhafiye.com web sitesi çerezleri ayrıca; arama motorlarını, web sitesi 
ve/veya web sitesinin reklam verdiği internet sitelerini ziyaret ettiğinizde ilginizi 
çekebileceğini düşündüğü reklamları size sunabilmek için “reklam teknolojisini” 
devreye sokmak amacıyla kullanabilir. 
5) Şirketimiz kişisel verileri hangi amaçlarla kullanıyor? 
Şirketimiz, mevzuatın izin verdiği durumlarda ve ölçüde kişisel bilgilerinizi 
kaydedebilecek, saklayabilecek, güncelleyebilecek, üçüncü kişilere açıklayabilecek, 
devredebilecek, sınıflandırabilecek ve işleyebilecektir. Kişisel verileriniz şu amaçlarla 
kullanılmaktadır: 
Web sitesi üzerinden işlem yapanın/yaptıranın kimlik bilgilerini teyit etmek, 
Müşteri ilişkileri yönetimi süreçlerinin planlanması ve icrası, 
Yasal yükümlülüklerimizi yerine getirebilmek. 
6) Şirketimiz kişisel verilerinizi nasıl koruyor? 
Şirketimiz ile paylaşılan kişisel veriler, Şirketimiz gözetimi ve kontrolü altındadır. 
Şirketimiz, yürürlükteki ilgili mevzuat hükümleri gereğince bilginin gizliliğinin ve 
bütünlüğünün korunması amacıyla gerekli organizasyonu kurmak ve teknik önlemleri 
almak ve uyarlamak konusunda veri sorumlusu sıfatıyla sorumluluğu üstlenmiştir. 
7) Şirketimiz kişisel verilerinizi paylaşıyor mu? 
Müşterilerimize ait kişisel verilerin üçüncü kişiler ile paylaşımı, müşterilerin izni 
çerçevesinde gerçekleşmekte ve kural olarak müşterimizin onayı olmaksızın kişisel 
verileri üçüncü kişilere aktarılmamaktadır. 
8) Kişisel Verilerin Korunması Kanunu’ndan doğan haklarınız nelerdir? 
KVKK uyarınca kişisel verilerinizin; işlenip işlenmediğini öğrenme, silinmesini talep 
etme gibi haklarınız bulunmaktadır. 
9) Kişisel verilerle ilgili mevzuat değişikliklerinden nasıl haberdar olabilirim? 
Şirketimiz, yasal değişiklikleri bu sayfa üzerinden güncelleyecektir. 
10) Verinin güncel ve doğru tutulduğundan nasıl emin olabilirim? 
KVKK’nın 4. maddesi uyarınca şirketimiz kişisel verilerinizi doğru ve güncel olarak tutma 
yükümlülüğü bulunmaktadır.
        </p>
      </section>

     

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">7. İletişim</h2>
        <p>
          Kişisel verilerinizle ilgili her türlü talep ve soru için bizimle iletişime geçebilirsiniz.
          İletişim bilgileri için{" "}
          <Link to="/contact" className="text-blue-500">
            İletişim Sayfası
          </Link>{" "}
          ziyaret edebilirsiniz.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">8. Değişiklikler</h2>
        <p>
          Bu KVKK sayfası zaman zaman güncellenebilir. Değişiklikler bu sayfada yayınlanacaktır.
          Lütfen düzenli olarak bu sayfayı kontrol ediniz.
        </p>
      </section>
    </div>
  );
};

export default KvkkPage;
